module.exports = __webpack_public_path__ + "static/media/amazon_boats.037bd63b.jpeg";